import { FC, useContext } from 'react';
import { Menu, Spinner } from '@chakra-ui/react';

import { useApplicationSendLixiXml } from '~/core/shared/api/middle-office/application';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const LixiSendXmlMenuItem: FC = () => {
  const { applicationUuid, definition } = useContext(ApplicationContext);
  const {
    action: { text },
  } = useContext(DocumentDetailsViewActionContext);
  const { sendLixiXml, isPending } = useApplicationSendLixiXml(definition);

  const sendLixiXML = async (): Promise<void> => {
    try {
      await sendLixiXml({
        uuid: applicationUuid,
        data: { uuid: applicationUuid },
      });
    } catch {
      // Error is handled in useApplicationSendLixiXml
    }
  };

  return (
    <Menu.Item onClick={sendLixiXML} value="send-lixi-xml">
      {isPending && <Spinner size="xs" />}
      {text}
    </Menu.Item>
  );
};
